export const normalizeForDedup = (value) =>
  (value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '')
    .trim()
    .toLowerCase()

const formatBirthdateForDedup = (birthdate) => {
  if (!birthdate) return ''

  if (birthdate instanceof Date) {
    return `${birthdate.getDate()}-${birthdate.getMonth() + 1}-${birthdate.getFullYear()}`
  }

  if (typeof birthdate === 'object') {
    const { day, month, year } = birthdate
    if (day !== undefined && month !== undefined && year !== undefined) {
      return `${day}-${month}-${year}`
    }
  }

  return `${birthdate}`
}

export const getChildDedupKey = ({ parentId = 'noparent', firstName, lastName, birthdate }) =>
  `child:${parentId}:${normalizeForDedup(firstName)}:${normalizeForDedup(lastName)}:${formatBirthdateForDedup(birthdate)}`
